"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FALSE_TASK = exports.DEFAULT_TRUE_TASK = exports.OPTIONAL_TASK = exports.DEFAULT_TASK = exports.TaskFiltersOperatorEnum = exports.TaskCommentTypeEnum = exports.TaskPriorityEnum = exports.TaskTypeEnum = exports.TaskSourceEnum = exports.TaskProductEnum = void 0;
const t = __importStar(require("io-ts"));
const utils_1 = require("../../utils");
var TaskProductEnum;
(function (TaskProductEnum) {
    TaskProductEnum["ACADEMY"] = "ACADEMY";
    TaskProductEnum["KNOWLEDGE"] = "KNOWLEDGE";
    TaskProductEnum["SELFCARE"] = "SELFCARE";
})(TaskProductEnum = exports.TaskProductEnum || (exports.TaskProductEnum = {}));
var TaskSourceEnum;
(function (TaskSourceEnum) {
    TaskSourceEnum["MAYDAY_WEB"] = "MAYDAY_WEB";
    TaskSourceEnum["SELFCARE"] = "SELFCARE";
    TaskSourceEnum["CHROME_EXT"] = "CHROME_EXT";
})(TaskSourceEnum = exports.TaskSourceEnum || (exports.TaskSourceEnum = {}));
var TaskTypeEnum;
(function (TaskTypeEnum) {
    TaskTypeEnum["CONTENT_FEEDBACK"] = "CONTENT_FEEDBACK";
    TaskTypeEnum["FEEDBACK"] = "FEEDBACK";
    TaskTypeEnum["FEEDBACK_ACADEMY"] = "FEEDBACK_ACADEMY";
    TaskTypeEnum["CONTENT_FEEDBACK_ACADEMY"] = "CONTENT_FEEDBACK_ACADEMY";
    TaskTypeEnum["CUSTOM_FEEDBACK"] = "CUSTOM_FEEDBACK";
    TaskTypeEnum["CONTENT_OBSOLETE"] = "CONTENT_OBSOLETE";
    TaskTypeEnum["INFORMATION"] = "INFORMATION";
    TaskTypeEnum["TRENDING_TOPICS"] = "TRENDING_TOPICS";
    TaskTypeEnum["CUSTOM"] = "CUSTOM";
})(TaskTypeEnum = exports.TaskTypeEnum || (exports.TaskTypeEnum = {}));
var TaskPriorityEnum;
(function (TaskPriorityEnum) {
    TaskPriorityEnum["NONE"] = "NONE";
    TaskPriorityEnum["LOW"] = "LOW";
    TaskPriorityEnum["MEDIUM"] = "MEDIUM";
    TaskPriorityEnum["HIGH"] = "HIGH";
})(TaskPriorityEnum = exports.TaskPriorityEnum || (exports.TaskPriorityEnum = {}));
var TaskCommentTypeEnum;
(function (TaskCommentTypeEnum) {
    TaskCommentTypeEnum["COMMENT"] = "COMMENT";
    TaskCommentTypeEnum["INTERNAL"] = "INTERNAL";
})(TaskCommentTypeEnum = exports.TaskCommentTypeEnum || (exports.TaskCommentTypeEnum = {}));
var TaskFiltersOperatorEnum;
(function (TaskFiltersOperatorEnum) {
    TaskFiltersOperatorEnum["AND"] = "AND";
    TaskFiltersOperatorEnum["OR"] = "OR";
})(TaskFiltersOperatorEnum = exports.TaskFiltersOperatorEnum || (exports.TaskFiltersOperatorEnum = {}));
exports.DEFAULT_TASK = {
    taskId: t.number,
    type: (0, utils_1.tDotEnum)(TaskTypeEnum),
    status: t.string,
    source: (0, utils_1.tDotEnum)(TaskSourceEnum),
    product: (0, utils_1.tDotEnum)(TaskProductEnum),
    hasLinkedContent: t.boolean,
    createdAt: t.string,
};
exports.OPTIONAL_TASK = {
    customTypeName: t.string,
    authorId: t.number,
    assigneeId: t.number,
    priority: (0, utils_1.tDotEnum)(TaskPriorityEnum),
    deadline: t.string,
};
exports.DEFAULT_TRUE_TASK = {
    taskId: 1,
    type: TaskTypeEnum.FEEDBACK,
    status: "status",
    source: TaskSourceEnum.SELFCARE,
    product: TaskProductEnum.SELFCARE,
    hasLinkedContent: true,
    authorId: 1,
    assigneeId: 1,
    priority: TaskPriorityEnum.LOW,
    deadline: "",
    createdAt: "2024",
};
exports.DEFAULT_FALSE_TASK = {
    taskId: "task-id",
    type: "task-type",
    status: "status",
    source: "source",
    product: "product",
    hasLinkedContent: true,
    authorId: 1,
    assigneeId: 1,
    priority: "priority",
    deadline: "deadline",
};
